var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lead-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52851 1.52827C7.78886 1.26792 8.21097 1.26792 8.47132 1.52827L11.8047 4.8616C12.065 5.12195 12.065 5.54406 11.8047 5.80441C11.5443 6.06476 11.1222 6.06476 10.8618 5.80441L8.66659 3.60915V9.99967C8.66659 10.3679 8.36811 10.6663 7.99992 10.6663C7.63173 10.6663 7.33325 10.3679 7.33325 9.99967V3.60915L5.13799 5.80441C4.87764 6.06476 4.45553 6.06476 4.19518 5.80441C3.93483 5.54406 3.93483 5.12195 4.19518 4.8616L7.52851 1.52827ZM1.99992 9.33301C2.36811 9.33301 2.66659 9.63148 2.66659 9.99967V10.7997C2.66659 11.3707 2.6671 11.7589 2.69162 12.059C2.7155 12.3513 2.75878 12.5007 2.81191 12.605C2.93974 12.8559 3.14372 13.0599 3.3946 13.1877C3.49886 13.2408 3.64833 13.2841 3.94061 13.308C4.24067 13.3325 4.62887 13.333 5.19992 13.333H10.7999C11.371 13.333 11.7592 13.3325 12.0592 13.308C12.3515 13.2841 12.501 13.2408 12.6052 13.1877C12.8561 13.0599 13.0601 12.8559 13.1879 12.605C13.2411 12.5007 13.2843 12.3513 13.3082 12.059C13.3327 11.7589 13.3333 11.3707 13.3333 10.7997V9.99967C13.3333 9.63148 13.6317 9.33301 13.9999 9.33301C14.3681 9.33301 14.6666 9.63148 14.6666 9.99967V10.8272C14.6666 11.3639 14.6666 11.8068 14.6371 12.1676C14.6065 12.5423 14.5408 12.8868 14.3759 13.2103C14.1203 13.7121 13.7123 14.12 13.2106 14.3757C12.887 14.5406 12.5425 14.6063 12.1678 14.6369C11.807 14.6664 11.3641 14.6664 10.8275 14.6663H5.17237C4.63573 14.6664 4.19283 14.6664 3.83204 14.6369C3.4573 14.6063 3.11283 14.5406 2.78928 14.3757C2.28751 14.12 1.87956 13.7121 1.6239 13.2103C1.45904 12.8868 1.39333 12.5423 1.36271 12.1676C1.33324 11.8068 1.33324 11.3639 1.33325 10.8272L1.33325 9.99967C1.33325 9.63148 1.63173 9.33301 1.99992 9.33301Z",
    fill: "#0157FF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload01);
export default __webpack_public_path__ + "static/media/upload-01.8d5bf36f607d21d7dfa21ca14093ea1e.svg";
export { ForwardRef as ReactComponent };